/**
 * Orders
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext } from 'react';
import useQuery from '../../utils/hook/useQuery';

// Context
import AuthContext, { AuthConsumer } from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  actionRetrieveRubikaOrdersAction,
  cancelOrderAction,
  getAllOrdersReportAction, getVitrinOrdersAction, getOrdersAction
} from '../orders/actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllOrders,
  makeSelectProcessingCountList,
  makeSelectDeliveredCountList,
  makeSelectDeliveringCountList,
  makeSelectDeliverdPostCountList,
  makeSelectReturnedCountList, makeSelectVitrinOrdersList,
  makeSelectIncomingOrdersList,
  makeSelectVitrinOrdersCount,
  makeSelectIncomingOrdersCount,
} from '../orders/selectors';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Divider, Tabs, Tab
} from '@material-ui/core';

import { Box, Trolley, Truck, Deliverd, SupplyingIcon } from '../orders/customIcon';

// Components
import VitrinList from '../orders/listVitrin';
import Pagination from '@material-ui/lab/Pagination';
import Can from '../../components/Can';
import EXCEL from '../orders/excel';
import OrdersMob from '../orders/mobileView';
import windowSize from '../../utils/hook/useWindowResize';

// Helper
import {
  removeEmptyValueObject,
  translate,
  checkMatchMedia,
} from '../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  Payload,
  Status,
  cancelPayload,
  PayloadAllUpdate,
} from '../orders/interfaces';
import { Link } from 'react-router-dom';
import RonadIcons from '../../components/iconComponent';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // '@media (max-width: 480px)': {
      //   marginLeft: '75px',
      // },
    },
    paper: {},
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    mdiDresserIcon: {
      color: '#329926',

      // backgroundColor: '#D6EBD3',
    },
    mdiClipboardMultipleOutlineIcon: {
      color: '#6276F7',
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#dfa01f',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },

    cardContentOrder: {
      padding: '0',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      marginTop: '45px',

      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      marginTop: '5px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'row-reverse',
      // width: '100%',
      '@media (max-width: 480px)': {
        display: 'none',
        flexDirection: 'column-reverse',
        width: '100%',
      },
    },
    titleBar: {
      padding: '5px 2px',
      width: '100%',
      borderRadius: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '@media (max-width: 480px)': {
        width: '100%',
        marginLeft: '-70px',

        marginTop: '55px',
        flexDirection: 'column',
        alignItem: 'center',
        fontSize: '12px',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      '@media (max-width: 480px)': {
        marginLeft: '-5px',

        fontSize: '12px',
      },
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
  })
);

const VitrinOrders: FunctionComponent<Props> = (props: Props) => {
  const { filtersValues, setFiltersValues } = useQuery({ page: 0, size: 10, 'parentId.specified': false });
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );

  const [id, setId] = useState(-1 as number);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [cancelDescription, setCancelDescription] = useState('' as string);
  const [lastUpdate, setLastUpdate] = useState(
    '2019-07-02T17:15:03+04:30' as string
  );
  const [selected, setSelected] = useState<string[]>([]);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();
  const classes = useStyles();



  // Bad Bad Bad.. :(
  props.ordersList[0]?.created &&
    props.ordersList[0]?.created > lastUpdate &&
    setLastUpdate(props.ordersList[0]?.created);

  useEffect(() => {
    getOrders();
    getVitrinOrders();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getOrders = () => {
    const { page, size } = filtersValues;
    props.ordersDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const getVitrinOrders = () => {
    const { page, size } = filtersValues;
    props.vitrinOrdersDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const handleCancelOrder = async () => {
    await props.cancelOrderDispatch({
      id,
      body: { description: cancelDescription },
    });
    getOrders();
    getVitrinOrders();
    setOpenConfirmCancel(false);
  };

  const handleCardClose = () => {
    delete filtersValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10,
    });
  };
  const handleCardClick = (name: any) => {
    switch (name) {
      case 'progress':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ASSIGNED', 'PICKED', 'PACKAGED', 'BUNDLED'],

          page: 0,
          size: 10,
        });
        break;
      case 'courier':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['LOADED', 'DELIVERED_TO_COURIER'],

          page: 0,
          size: 10,
        });
        break;
      case 'delivered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED'],
          page: 0,
          size: 10,
        });
        break;
      case 'post':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED_TO_POST'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const changeStatusOrder = () => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: previewState, description: '' },
      pagination: filtersValues,
    });
    setOpenConfirmUpdateState(false);
  };
  const changeStatusOrderWhitId = (data: any) => {
    const { ids, status, description } = data;
    props.updateAllOrderStatusDispatch({
      ids,
      status,
      description,
      pagination: filtersValues,
    });

    // props.updateOrderStatusDispatch({
    //   id,
    //   body,
    //   pagination: filtersValues,
    // });
    setOpenConfirmUpdateState(false);
  };

  const handleOpenConfirmCancele = (id: number) => {
    setOpenConfirmCancel(true);
    setId(id);
  };
  const handleOpenConfirmUpdateState = (data: { id: number; body: Status }) => {
    setOpenConfirmUpdateState(true);
    setId(data.id);
    setPreviewState(data.body);
  };

  const handleClose = () => {
    setOpenConfirmCancel(false);
    setOpenConfirmUpdateState(false);
    setOpenSize(false);
  };

  const findOrderStatus = (id: number) => {
    const status = props.ordersList.find(order => order.id === id)?.status;
    return status && translate(status, 'order');
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'progress':
        return (
          status.includes('ASSIGNED') &&
          status.includes('PICKED') &&
          status.includes('PACKAGED') &&
          status.includes('BUNDLED')
        );
      case 'courier':
        return (
          status.includes('LOADED') && status.includes('DELIVERED_TO_COURIER')
        );
      case 'delivered':
        return status.includes('DELIVERED');
      case 'post':
        return status.includes('DELIVERED_TO_POST');
    }
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.ordersList.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const selectItem = (id: string) => {
    const selectedIndex = selected.indexOf(id);
    if (selectedIndex > -1) {
      setSelected(selected.filter(el => el != id));
    } else {
      setSelected([...selected, id]);
    }
  };

  return (
    <AuthConsumer>
      {({ user }) =>
        (
          <div className={classes.root}>
            <Grid container md={12} spacing={2} className={classes.mobile}>
              <Grid container lg={12} spacing={2} xs={12}>
                <Grid item md={6} lg xs={12}>
                  <Card
                    className={
                      checkActiveCard('progress')
                        ? classes.boxshadow
                        : classes.cards
                    }
                  >
                    <CardHeader
                      action={
                        checkActiveCard('progress') && (
                          <IconButton
                            aria-label="close"
                            onClick={handleCardClose}
                            className={classes.iconHeader}
                            data-cy="cardCloseBtn"
                          >
                            <RonadIcons name="times" size={0.8} className="text-danger"/>
                          </IconButton>
                        )
                      }
                    />
                    <CardContent className={classes.cardContent}>
                      <IconButton
                        type="submit"
                        onClick={name => handleCardClick('progress')}
                        aria-label="search"
                        style={{
                          backgroundColor: '#FFEDDE',
                          height: '30%',
                          width: '28%',
                          borderRadius: '4px',
                          margin: '-20px 0',
                        }}
                        data-cy="progressCardBtn"
                      >
                        <Trolley />
                      </IconButton>
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          marginRight: '10px',
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="h6"
                          style={{ fontWeight: 600, marginTop: '-20px' }}
                          data-cy="processingCount"
                        >
                          {props.processingCount}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            marginBottom: '-20px',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >
                          در حال پردازش
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <Card
                    className={
                      checkActiveCard('courier')
                        ? classes.boxshadow
                        : classes.cards
                    }
                  >
                    <CardHeader
                      action={
                        checkActiveCard('courier') && (
                          <IconButton
                            aria-label="close"
                            onClick={handleCardClose}
                            className={classes.iconHeader}
                            data-cy="cardCloseBtn"
                          >
                            <RonadIcons name="times" size={0.8} className="text-danger"/>
                          </IconButton>
                        )
                      }
                    />
                    <CardContent className={classes.cardContent}>
                      <IconButton
                        type="submit"
                        aria-label="search"
                        onClick={name => handleCardClick('courier')}
                        style={{
                          backgroundColor: '#DFE3FD',
                          height: '60%',
                          width: '30%',
                          borderRadius: '4px',
                          margin: '-20px 0',
                        }}
                        data-cy="courierCardBtn"
                      >
                        <Truck />
                      </IconButton>
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          marginRight: '10px',
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="h6"
                          style={{ fontWeight: 600, marginTop: '-20px' }}
                          data-cy="deliveringCount"
                        >
                          {props.deliveringCount}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            marginBottom: '-20px',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >
                          تحویل پیک شده
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <Card
                    className={
                      checkActiveCard('post')
                        ? classes.boxshadow
                        : classes.cards
                    }
                  >
                    <CardHeader
                      action={
                        checkActiveCard('post') && (
                          <IconButton
                            aria-label="close"
                            onClick={handleCardClose}
                            className={classes.iconHeader}
                            data-cy="cardCloseBtn"
                          >
                            <RonadIcons name="times" size={0.8} className="text-danger"/>
                          </IconButton>
                        )
                      }
                    />

                    <CardContent className={classes.cardContent}>
                      <IconButton
                        type="submit"
                        aria-label="search"
                        onClick={name => handleCardClick('post')}
                        style={{
                          backgroundColor: '#E9CAF2',
                          height: '50%',
                          width: '30%',
                          borderRadius: '4px',
                          margin: '-20px 0',
                        }}
                        data-cy="postCardBtn"
                      >
                        <Deliverd />
                      </IconButton>
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          marginRight: '10px',
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="h6"
                          style={{ fontWeight: 600, marginTop: '-20px' }}
                          data-cy="deliverdPostCount"
                        >
                          {props.deliverdPostCount}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            marginBottom: '-20px',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >
                          تحویل پست
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <Card
                    className={
                      checkActiveCard('delivered')
                        ? classes.boxshadow
                        : classes.cards
                    }
                  >
                    <CardHeader
                      action={
                        checkActiveCard('delivered') && (
                          <IconButton
                            aria-label="close"
                            onClick={handleCardClose}
                            className={classes.iconHeader}
                            data-cy="cardCloseBtn"
                          >
                            <RonadIcons name="times" size={0.8} className="text-danger"/>
                          </IconButton>
                        )
                      }
                    />
                    <CardContent className={classes.cardContent}>
                      <IconButton
                        type="submit"
                        aria-label="search"
                        onClick={name => handleCardClick('delivered')}
                        style={{
                          padding: '17px 0',
                          backgroundColor: '#D6EBD3',
                          height: '50%',
                          width: '30%',
                          borderRadius: '4px',
                          margin: '-20px 0',
                        }}
                        data-cy="deliveredCardBtn"
                      >
                        <Box />
                      </IconButton>
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          marginRight: '10px',
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="h6"
                          style={{ fontWeight: 600, marginTop: '-20px' }}
                          data-cy="deliveredCount"
                        >
                          {props.deliveredCount}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            marginBottom: '-20px',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >
                          تحویل مشتری
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <Card
                    className={
                      checkActiveCard('delivered')
                        ? classes.boxshadow
                        : classes.cards
                    }
                  >
                    <CardHeader
                      action={
                        checkActiveCard('delivered') && (
                          <IconButton
                            aria-label="close"
                            onClick={handleCardClose}
                            className={classes.iconHeader}
                            data-cy="cardCloseBtn"
                          >
                            <RonadIcons name="times" size={0.8} className="text-danger"/>
                          </IconButton>
                        )
                      }
                    />
                    <CardContent className={classes.cardContent}>
                      <Link to={`/orders-returned`}>
                        <IconButton
                          type="submit"
                          aria-label="search"
                          style={{
                            padding: '17px 0',
                            backgroundColor: '#D6EBD3',
                            borderRadius: '4px',
                            margin: '-20px 0',
                          }}
                          data-cy="deliveredCardBtn"
                        >
                          <SupplyingIcon />
                        </IconButton>
                      </Link>
                      {/* <IconButton
                        type="submit"
                        aria-label="search"
                        onClick={name => handleCardClick('delivered')}
                        style={{
                          padding: '17px 0',
                          backgroundColor: '#D6EBD3',
                          height: '50%',
                          width: '30%',
                          borderRadius: '4px',
                          margin: '-20px 0',
                        }}
                        data-cy="deliveredCardBtn"
                      >
                        <SupplyingIcon />
                      </IconButton> */}
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          marginRight: '10px',
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="h6"
                          style={{ fontWeight: 600, marginTop: '-20px' }}
                          data-cy="deliveredCount"
                        >
                          {props.returnedCount}
                        </Typography>
                        <Typography
                          style={{
                            fontSize: '16px',
                            marginBottom: '-20px',
                            fontWeight: 550,
                            color: '#666666',
                          }}
                        >
                          بازگردانده شده
                        </Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              {/* <Grid item lg={4} xs={6}>
      <Card className={classes.chart}>
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography className={classes.typographyCards}>
            تعداد آیتم‌های محموله
          </Typography>
          <Select value={'۷ روز گذشته'}>
            <MenuItem value={'۷ روز گذشته'}>۷ روز گذشته</MenuItem>
          </Select>
        </Grid>
        <div style={{marginTop: '10px'}}>
          <Chart data={data} height={230}>
            <ArgumentAxis />
            <ValueAxis position={'right'} />

            <LineSeries valueField="value" argumentField="argument" />
            <EventTracker />
            <Tooltip />
          </Chart>
        </div>
      </Card>
    </Grid> */}
              {/* <Grid item lg={3} xs={6}>
      <Card className={classes.progress}>
        <Typography
          className={classes.typographyCards}
          style={{
            width: '60%',
            textAlign: 'end',
          }}
        >
          محموله هر انبار
        </Typography>
        <div style={{textAlign: 'center', margin: '30px auto'}}>
          <CircularProgress
            size={140}
            style={{
              position: 'relative',
              color: '#6276F7',
              // bottom: '-20%',
              // right: '30%',
            }}
            variant="determinate"
            value={60}
            thickness={6}
          />
          <Typography
            style={{
              position: 'relative',
              bottom: '85px',
              fontWeight: 900,
            }}
            variant="caption"
            component="div"
            color="textSecondary"
          >
            {'754 سفارش'}
          </Typography>
        </div>
      </Card>
    </Grid> */}
            </Grid>
            <Grid container spacing={1} style={{ marginTop: '20px' }}>
              <Card className={classes.card}>
                <CardHeader
                  avatar={
                    <Grid>
                      <Typography className={classes.typographyCards}>
                        لیست سفارش‌های ویترین
                      </Typography>
                    </Grid>
                  }
                  action={
                    <div className={classes.btnBox}>
                      <Can
                        role={user.role}
                        perform="orders:grouping-create"
                        yes={() => (
                          <>
                            <Can
                              role={user.role}
                              perform="orders:create"
                              yes={() => (
                                <>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() =>
                                      props.history.push('/orders-create')
                                    }
                                    startIcon={
                                      <RonadIcons name='plus' className='text-primary' size={0.7}/>
                                    }
                                    size={
                                      checkMatchMedia('(max-width: 1024px)')
                                        ? 'small'
                                        : 'large'
                                    }
                                  >{`ایجاد سفارش `}</Button>
                                </>
                              )}
                            />
                            <Button
                              variant="contained"
                              color="primary"
                              style={{ marginLeft: '8px' }}
                              onClick={() =>
                                props.history.push('/create-grouping-order')
                              }
                              startIcon={
                                <RonadIcons name='plus' className='text-white' size={0.7}/>
                              }
                              size={
                                checkMatchMedia('(max-width: 1024px)')
                                  ? 'small'
                                  : 'large'
                              }
                            >{`ایجاد گروهی سفارش`}</Button>
                          </>
                        )}
                      />

                      <Can
                        role={user.role}
                        perform="orders:btnGetNewOrders"
                        yes={() => (
                          <>
                            <Button
                              variant="contained"
                              color="secondary"
                              size={
                                checkMatchMedia('(max-width: 1024px)')
                                  ? 'small'
                                  : 'large'
                              }
                              onClick={() =>
                                props.actionRetrieveRubikaOrdersDispatch({})
                              }
                            >{`دریافت سفارش جدید`}</Button>
                          </>
                        )}
                      />

                      <Can
                        role={user.role}
                        perform="orders:downloadReportCSV"
                        yes={() => (
                          <>
                            <EXCEL
                              ordersDispatch={props.allOrdersDispatch}
                              data={props.allOrders}
                              filtersValues={filtersValues}
                              loading={props.loading}
                            />
                            {/* <ExelExport
                        data={convertArrayItemsToString()}
                        loading={props.loading}
                        filtersValues={filtersValues}
                        handleRequest={props.allOrdersDispatch}
                      /> */}
                          </>
                        )}
                      />
                      {selected.length >= 1 && (
                        <Link
                          to={`/orders/exit-receiptsgroup/${selected}`}
                          target="_blank"
                          style={{ textDecoration: 'none', margin: '0px 10px' }}
                        >
                          <Button
                            size='large'
                            variant="contained"
                            color="secondary"
                            startIcon={<RonadIcons name='receipt' size={1} />}
                          >
                            {'چاپ رسید خروج'}
                          </Button>
                        </Link>
                      )}

                    </div>
                  }
                />
                <CardContent className={classes.cardContentOrder}>
                  <Grid
                    container
                    lg={12}
                    md={12}
                    className={classes.cardContentlist}
                  >
                    <Grid container item lg={12} md={12}>
                      <Grid container item xs={12} md={12} lg={12}>
                        {props.loading ? (
                          <div className={classes.loading}>
                            <CircularProgress />
                          </div>
                        ) : (
                          <>
                            {
                              props.vitrinOrdersList?.length > 0 ? (
                                <VitrinList
                                  data={props.vitrinOrdersList}
                                  handleConfirmCanceleBox={
                                    handleOpenConfirmCancele
                                  }
                                  changeStatusOrderWhitId={
                                    changeStatusOrderWhitId
                                  }
                                  handleOpenConfirmUpdateState={
                                    handleOpenConfirmUpdateState
                                  }
                                  handleSelect={(id: number) => {
                                    selectItem(id);
                                    setId(id);
                                  }}
                                  selectedItems={selected}
                                  selectAll={handleSelectAllClick}
                                />
                              ) :
                                (
                                  <Typography variant="h3" component="div">
                                    سفارشی موجود نیست
                                  </Typography>
                                )}
                          </>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ padding: '20px 10px 0 10px' }}
                      >
                        {props.vitrinOrdersList.length > 0 && (
                          <FormControl
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                              {' '}
                              تعداد نمایش در هر صفحه:
                            </div>
                            <Select
                              open={openSize}
                              onClose={handleClose}
                              onOpen={() => setOpenSize(true)}
                              value={filtersValues.size}
                              onChange={handleChangeSizePage}
                            >
                              <MenuItem value={10}>10</MenuItem>
                              <MenuItem value={20}>20</MenuItem>
                              <MenuItem value={50}>50</MenuItem>
                              <MenuItem value={100}>100</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                      <Grid
                        xs={12}
                        sm={6}
                        container
                        item
                        direction="row-reverse"
                        style={{ padding: '20px 10px 0 10px' }}
                      >
                        {props.vitrinOrdersList.length > 0 && (
                          <Pagination
                            className={classes.pagination}
                            count={Math.ceil(props.vitrinOrdersCount / filtersValues.size)}
                            color="secondary"
                            page={filtersValues.page + 1}
                            onChange={handleChangePage}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Dialog
              open={openConfirmCancel}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogContent>
                <div
                  style={{
                    position: 'absolute',
                    left: '3px',
                    top: '10px',
                    zIndex: 10,
                  }}
                >
                  {handleClose ? (
                    <IconButton
                      aria-label="close"
                      // className={classes.closeButton}
                      onClick={handleClose}
                    >
                      <RonadIcons name="times" size={0.8}/>
                    </IconButton>
                  ) : null}
                </div>

                <div
                  className={classes.cancelTitle}
                >{`از لغو سفارش با شناسه ${id} مطمئن هستید؟`}</div>
                <Grid item xs={12} style={{ marginTop: '16px' }}>
                  <TextField
                    variant="outlined"
                    className={classes.textArea}
                    placeholder={`علت لغو...`}
                    value={cancelDescription}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setCancelDescription(e.target.value)
                    }
                  />
                </Grid>
                <Divider style={{ width: '100%', marginTop: '16px' }} />
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  spacing={2}
                  justifyContent="center"
                  style={{ textAlign: 'center', marginBottom: '8px' }}
                >
                  <Grid item xs={12}>
                    <Button
                      style={{ marginLeft: '8px' }}
                      autoFocus
                      onClick={handleClose}
                      variant="outlined"
                      color="primary"
                      size="large"
                      data-cy="closeCancelation"
                    >
                      {`انصراف
`}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleCancelOrder}
                      disabled={!(cancelDescription.length > 0)}
                      size="large"
                      data-cy="submitCancelation"
                      color="primary"
                    >
                      {`لغو سفارش`}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>

            <Dialog
              fullWidth
              open={openConfirmUpdateState}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogContent>
                <div
                  style={{
                    position: 'absolute',
                    left: '17px',
                    zIndex: 10,
                  }}
                >
                  {handleClose ? (
                    <IconButton
                      aria-label="close"
                      // className={classes.closeButton}
                      onClick={handleClose}
                    >
                      <RonadIcons name="times" size={0.8}/>
                    </IconButton>
                  ) : null}
                </div>
                <div className={classes.editIcon}>
                  <RonadIcons name='pencil'
                    size={4}
                    className='text-primary'
                  />
                </div>
                <div className={classes.cancelTitle}>
                  {`از تغییر تگ وضعیت سفارش
            با شناسه  ${id} از
"${id > -1 && findOrderStatus(id)}"
به
" ${translate(previewState.replace(/"/g, '') as Status, 'order')}"


مطمئن هستید؟`}
                </div>
              </DialogContent>
              <DialogActions className={classes.actionsBox}>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <Button
                      fullWidth
                      autoFocus
                      onClick={handleClose}
                      variant="contained"
                      color="secondary"
                      size="large"
                      data-cy="closeChangeTag"
                    >
                      {`خیر`}
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={changeStatusOrder}
                      size="large"
                      data-cy="submitChangeTag"
                    >
                      {`بله`}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          </div>
        )
      }
    </AuthConsumer>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  vitrinOrdersList: makeSelectVitrinOrdersList(),
  incomingOrdersList: makeSelectIncomingOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  vitrinOrdersCount: makeSelectVitrinOrdersCount(),
  incomingOrdersCount: makeSelectIncomingOrdersCount(),
  deliveringCount: makeSelectDeliveringCountList(),
  deliveredCount: makeSelectDeliveredCountList(),
  processingCount: makeSelectProcessingCountList(),
  deliverdPostCount: makeSelectDeliverdPostCountList(),
  returnedCount: makeSelectReturnedCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    vitrinOrdersDispatch: (payload: Payload) => dispatch(getVitrinOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    actionRetrieveRubikaOrdersDispatch: (payload: {
      date?: String;
      from?: number;
      to?: number;
    }) => dispatch(actionRetrieveRubikaOrdersAction(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(VitrinOrders);
